export const SEARCH_PLACEHOLDERS = [
  "Search or paste an Amazon, eBay, or Flipkart link",
  "wooden sofa — compare stores",
  "MacBook Air under $900",
  "Nike sneakers across marketplaces",
  "Dyson vacuum best price",
  "iPhone 16 compare prices",
];

export const POPULAR_SEARCHES = [
  "wooden sofa",
  "sofa set",
  "MacBook Air",
  "wireless headphones",
  "running shoes",
  "Dyson vacuum",
];

const RELATED = {
  sofa: ["wooden sofa", "sofa set", "sectional sofa", "leather sofa", "outdoor sofa", "recliner sofa", "L shaped sofa"],
  couch: ["sectional couch", "leather couch", "sleeper couch", "modular couch"],
  chair: ["office chair", "dining chair", "accent chair", "lounge chair"],
  table: ["dining table", "coffee table", "console table", "office desk"],
  desk: ["standing desk", "home office desk", "writing desk"],
  bed: ["queen bed", "king bed", "platform bed", "bed frame"],
  laptop: ["MacBook Air", "gaming laptop", "laptop under $500", "Dell XPS", "Chromebook"],
  macbook: ["MacBook Air", "MacBook Pro", "MacBook 13 inch", "MacBook charger"],
  iphone: ["iPhone 16", "iPhone 16 Pro", "iPhone case", "AirPods"],
  headphone: ["wireless headphones", "noise cancelling headphones", "Sony headphones", "AirPods Max"],
  vacuum: ["Dyson vacuum", "robot vacuum", "stick vacuum", "cordless vacuum"],
  shoe: ["running shoes", "sneakers", "boots", "sandals"],
  sneaker: ["Nike sneakers", "Adidas sneakers", "white sneakers"],
  dress: ["wedding guest dress", "summer dress", "black dress"],
  watch: ["smart watch", "Apple Watch", "leather watch"],
  tv: ["4K TV", "OLED TV", "55 inch TV"],
  phone: ["iPhone 16", "Samsung Galaxy", "Pixel phone"],
};

export function relatedSearches(query) {
  const raw = String(query || "").trim().toLowerCase();
  if (!raw) return POPULAR_SEARCHES;
  const tokens = raw.split(/[^a-z0-9]+/).filter((t) => t.length > 2);
  const seen = new Set();
  const out = [];
  const add = (s) => {
    const key = s.toLowerCase();
    if (!key || key === raw || seen.has(key)) return;
    seen.add(key);
    out.push(s);
  };
  for (const [stem, rows] of Object.entries(RELATED)) {
    if (raw.includes(stem) || tokens.some((t) => stem.startsWith(t) || t.startsWith(stem))) {
      rows.forEach(add);
    }
  }
  if (!out.length) {
    Object.entries(RELATED).forEach(([stem, rows]) => {
      if (stem.startsWith(raw) || raw.startsWith(stem)) rows.forEach(add);
    });
  }
  if (out.length < 4) {
    add(`${raw} best price`);
    add(`${raw} compare stores`);
    POPULAR_SEARCHES.forEach(add);
  }
  return out.slice(0, 8);
}

export function storeLabel(product) {
  if (!product) return "Shoptosa";
  if (product.offer_count > 1) return `${product.offer_count} stores`;
  const id = String(product.id || "");
  if (product.source === "ebay" || id.startsWith("ebay:")) return "eBay";
  return product.store || product.seller_name || product.brand || (product.external ? "Partner store" : "Shoptosa");
}
